import { gql } from '@apollo/client';
import { SaleItemVariantFragment } from '../fragments/SaleItemVariantFragment';
/**
 * @const SaleItemVariantQuery
 * @since 1.0.0
 */
export const SaleItemVariantQuery = gql `
  query SaleItemVariantQuery($input: SaleItemVariantInput!) {
    saleItemVariant(input: $input) {
      ...SaleItemVariantFragment
    }
  }

  ${SaleItemVariantFragment}
`;
